const CLUSTER_GAP_MS = 5 * 60 * 1000;

/**
 * Clustering hints for denser mobile DM layouts (Instagram / iMessage style).
 */
export function getMessageClusterMeta(
  messages,
  index,
  {
    systemSender = "system",
    getSenderId = (m) => m?.sender_id ?? m?.sender?.user_id ?? null,
  } = {}
) {
  const msg = messages[index];
  const prev = index > 0 ? messages[index - 1] : null;
  const next = index < messages.length - 1 ? messages[index + 1] : null;

  const usable = (m) => {
    const sid = getSenderId(m);
    return m && !m.deleted_at && sid !== systemSender && sid != null;
  };

  const sameSenderAsPrev =
    usable(prev) && usable(msg) && getSenderId(prev) === getSenderId(msg);
  const sameSenderAsNext =
    usable(next) && usable(msg) && getSenderId(next) === getSenderId(msg);

  const prevGapMs =
    usable(prev) && msg?.created_at && prev.created_at
      ? new Date(msg.created_at) - new Date(prev.created_at)
      : Infinity;
  const nextGapMs =
    usable(next) && msg?.created_at && next.created_at
      ? new Date(next.created_at) - new Date(msg.created_at)
      : Infinity;

  const startOfRun = !sameSenderAsPrev || prevGapMs > CLUSTER_GAP_MS;
  const endOfRun = !sameSenderAsNext || nextGapMs > CLUSTER_GAP_MS;

  return {
    startOfRun,
    endOfRun,
    showTimestamp: endOfRun,
  };
}

export function formatDmTimestamp(iso, { compact = false } = {}) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  if (compact) {
    return d.toLocaleString(undefined, {
      hour: "numeric",
      minute: "2-digit",
    });
  }
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
